import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react';
import { toast } from 'sonner';
import api from '../../config/axions.config';
import Swal from 'sweetalert2';

const AdmissionTypeWise = () => {
  let navigate = useNavigate();
  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56'>
      <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
          <nav className="sm:hidden" aria-label="Back">
            <div className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
              <svg className="flex-shrink-0 w-5 h-5 mr-1 -ml-1 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              Back
            </div>
          </nav>

          <nav className="hidden sm:flex" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-4">
              <li>
                <div>
                  <div className="text-gray-400 hover:text-gray-500">
                    <svg className="flex-shrink-0 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                    </svg>
                    <span className="sr-only">Home</span>
                  </div>
                </div>
              </li>

              <li>
                <div className="flex items-center">
                  <svg className="flex-shrink-0 w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                  <div className="ml-3 text-sm text-gray-500 hover:text-gray-700" aria-current="page">
                    Admission Type wise reports
                  </div>
                </div>
              </li>
            </ol>
          </nav>

          <hr className="my-5 border-gray-300" />

          <div className="lg:flex lg:items-center lg:space-x-8">
            <div className="lg:flex-1 lg:min-w-0">
              <h1 className="text-2xl font-semibold text-primary-600">
              Admission Type Wise Reports
              </h1>
              <div className="mt-2 md:mt-3 sm:flex sm:items-center sm:space-x-6">
                <div className="flex items-center space-x-3">
                  <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                    <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                    <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                  </svg>
                  <span className="text-gray-600">
                    Reports
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 space-y-6">
            <div className="bg-white rounded-lg shadow">
              <div className="px-4 py-3 sm:px-6">
                <div className="flex items-center -ml-2">
                  <div title="Back" className="btn-circle" aria-label="Back" data-microtip-position="top" data-target="tooltip" role="button" onClick={()=>navigate('/dashboard/')}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                    </svg>
                  </div>

                  <h2 className="ml-2 text-lg font-medium leading-6 text-gray-900">
                    Dashboard
                  </h2>
                </div>
              </div>

              <div className="px-4 py-5 border-t border-gray-300 sm:px-6">
                <div className="md:flex md:items-center md:justify-between md:space-x-4">
                  <div className="flex-1 min-w-0 xl:max-w-lg">
                    <label htmlFor="searchPages" className="sr-only">
                      Search Admission Type
                    </label>
                    <div className="relative rounded-md">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg className="w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                      </div>
                      <input type="text" name="searchPages" id="searchPages" className="block w-full pr-4 py-2.5 rounded-lg focus:border-primary-600 focus:ring-primary-600 border border-gray-200 shadow-sm !pl-10" placeholder="Search Pages"/>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col">
                <div className="-my-2 sm:-mx-6 lg:-mx-8">
                  <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <div>
                      <table className="custom-table">
                        <thead>
                          <tr>
                            <th scope="col" className="!pr-0"></th>
                            <th scope="col">
                                Admission Type
                            </th>
                            <th scope="col" className="">
                              <span className="sr-only">
                                Actions
                              </span>
                            </th>
                          </tr>
                        </thead>

                        <tbody id="elements-container">
                          <tr className="draggable-element">
                            <td className="!pr-0">
                              <button type="button" className="cursor-move hover:text-primary-600">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 8h16M4 16h16" />
                                </svg>
                              </button>
                            </td>
                            <td className="font-medium">
                              <div href="#" title="" className="hover:text-primary-600">
                                Intern
                              </div>
                            </td>
                            <td>
                              <div className="flex items-center justify-end space-x-3">
                                <div className="dropdown lg:hidden">
                                  <button type="button" className="btn-cricle dropdown-toggle" data-toggle="dropdown" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="true">
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 256 256">
                                      <circle cx="128" cy="128" r="16"></circle>
                                      <circle cx="64" cy="128" r="16"></circle>
                                      <circle cx="192" cy="128" r="16"></circle>
                                    </svg>
                                  </button>

                                  <div className="dropdown-menu" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
                                    <div className="divide-y divide-gray-100">
                                      <div className="py-1" role="none">
                                        <div title="Preview" className="dropdown-item" role="menuitem" tabIndex="-1">
                                          Preview
                                        </div>
                                        <div title="Download" className="dropdown-item" role="menuitem" tabIndex="-1">
                                          Download
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div title="Preview" className="hidden btn-circle lg:inline-flex" aria-label="Preview" data-microtip-position="top" data-target="tooltip" role="button">
                                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                  </svg>
                                </div>

                                <div title="Download" className="hidden btn-circle lg:inline-flex" aria-label="Delete" data-microtip-position="top" data-target="tooltip" role="button">
                                  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M19 15V17C19 18.1046 18.1046 19 17 19H7C5.89543 19 5 18.1046 5 17V15M12 5V15M12 15L10 13M12 15L14 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr className="draggable-element">
                            <td className="!pr-0">
                              <button type="button" className="cursor-move hover:text-primary-600">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 8h16M4 16h16" />
                                </svg>
                              </button>
                            </td>
                            <td className="font-medium">
                              <div title="" className="hover:text-primary-600">
                                Full Year Project
                              </div>
                            </td>
                            <td>
                              <div className="flex items-center justify-end space-x-3">
                                <div className="dropdown lg:hidden">
                                  <button type="button" className="btn-cricle dropdown-toggle" data-toggle="dropdown" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="true">
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 256 256">
                                      <circle cx="128" cy="128" r="16"></circle>
                                      <circle cx="64" cy="128" r="16"></circle>
                                      <circle cx="192" cy="128" r="16"></circle>
                                    </svg>
                                  </button>
                                </div>

                                <div title="Preview" className="hidden btn-circle lg:inline-flex" aria-label="Preview" data-microtip-position="top" data-target="tooltip" role="button">
                                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                  </svg>
                                </div>

                                <div title="Download" className="hidden btn-circle lg:inline-flex" aria-label="Delete" data-microtip-position="top" data-target="tooltip" role="button">
                                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M19 15V17C19 18.1046 18.1046 19 17 19H7C5.89543 19 5 18.1046 5 17V15M12 5V15M12 15L10 13M12 15L14 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr className="draggable-element">
                            <td className="!pr-0">
                              <button type="button" className="cursor-move hover:text-primary-600">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 8h16M4 16h16" />
                                </svg>
                              </button>
                            </td>
                            <td className="font-medium">
                              <div title="" className="hover:text-primary-600">
                                Placement
                              </div>
                            </td>
                            <td>
                              <div className="flex items-center justify-end space-x-3">
                                <div className="dropdown lg:hidden">
                                  <button type="button" className="btn-cricle dropdown-toggle" data-toggle="dropdown" id="dropdownMenuButton" aria-haspopup="true" aria-expanded="true">
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 256 256">
                                      <circle cx="128" cy="128" r="16"></circle>
                                      <circle cx="64" cy="128" r="16"></circle>
                                      <circle cx="192" cy="128" r="16"></circle>
                                    </svg>
                                  </button>
                                </div>

                                <div title="Preview" className="hidden btn-circle lg:inline-flex" aria-label="Preview" data-microtip-position="top" data-target="tooltip" role="button">
                                  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                  </svg>
                                </div>

                                <div title="Download" className="hidden btn-circle lg:inline-flex" aria-label="Delete" data-microtip-position="top" data-target="tooltip" role="button">
                                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M19 15V17C19 18.1046 18.1046 19 17 19H7C5.89543 19 5 18.1046 5 17V15M12 5V15M12 15L10 13M12 15L14 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default AdmissionTypeWise
